import React from 'react';
import { Box } from '../../../Box';
import { ChevronDownOutlined, ChevronUpOutlined } from '../../../Icon';
import { OrderDirection } from '../../constants';
export var OrderArrow = function OrderArrow(_ref) {
  var orderDirection = _ref.orderDirection,
      visible = _ref.visible;
  return /*#__PURE__*/React.createElement(Box, {
    mt: "3px",
    ml: "xxxs"
  }, orderDirection === OrderDirection.Asc ? /*#__PURE__*/React.createElement(ChevronUpOutlined, {
    size: 14,
    visibility: visible ? 'visible' : 'hidden'
  }) : /*#__PURE__*/React.createElement(ChevronDownOutlined, {
    size: 14,
    visibility: visible ? 'visible' : 'hidden'
  }));
};